import getArchiveFanoutMailboxInfoForResult from "./getArchiveFanoutMailboxInfoForResult";
import type { ClientItemId } from "owa-client-ids";
import type { ConversationType } from "owa-graph-schema";
import type { TableView } from "owa-mail-list-store";
import getMailboxInfo from "owa-mail-mailboxinfo/lib/getMailboxInfo";

export default function getConversationClientIdForSearchResult(conversationType: ConversationType, tableView: TableView): ClientItemId {
    const archiveMailboxInfo = getArchiveFanoutMailboxInfoForResult(conversationType.MailboxGuids);
    if (archiveMailboxInfo) {
        return {
            Id: conversationType.ConversationId.Id,
            mailboxInfo: archiveMailboxInfo,
        };
    }
    
    return {
        Id: conversationType.ConversationId.Id,
        mailboxInfo: conversationType.ConversationId.mailboxInfo ?? getMailboxInfo(tableView),
    };
}
